<template>
	<div class="wrapper">
		<sub-ibox-title :is-show-back=true>
			<p slot="title">订单详情</p>
		</sub-ibox-title>
		<section class="content">
			<div class="detail-cont">
				<div class="m-b-5 fx m-r-5">
					<p class="w100">微信昵称</p>
					<div class="fx-fill">
						{{data.nickname}}
					</div>
				</div>
				<div class="m-b-5 fx m-r-5">
					<p class="w100">收货人姓名</p>
					<div class="fx-fill">
						{{data.consignee_name}}
					</div>
				</div>
				<div class="m-b-5 fx m-r-5">
					<p class="w100">收货人电话</p>
					<div class="fx-fill">
						{{data.consignee_phone}}
					</div>
				</div>
				<div class="m-b-5 fx m-r-5">
					<p class="w100">收货人地址</p>
					<div class="fx-fill">
						{{data.consignee_address}}
					</div>
				</div>
				<div class="m-b-5 fx m-r-5" v-show="data.status == 3">
					<p class="w100">货运单号</p>
					<div class="fx-fill">
						{{data.code_number}}
					</div>
				</div>
				<div class="m-b-5 fx m-r-5">
					<p class="w100">订单状态</p>
					<div class="status fx-fill" :class="[data.status == 1?'success':data.status == 3 ? 'fail': 'ing']">
						{{data.status | filterOrderStatus}}
					</div>
				</div>
				<div class="m-b-5 fx m-r-5">
					<p class="w100">订单总额</p>
					<div class="fx-fill">
						{{data.amount | filterMoney}}元
					</div>
				</div>
				<div class="m-b-5 fx m-r-5">
					<p class="w100">支付金额</p>
					<div class="fx-fill">
						{{data.pay_money | filterMoney}}元
					</div>
				</div>
				<div class="m-b-5 fx m-r-5">
					<p class="w100">下单时间</p>
					<div class="fx-fill">
						{{data.c_time | momentFmt}}
					</div>
				</div>
				<div class="m-b-5 fx m-r-5">
					<p class="w100">支付时间</p>
					<div class="fx-fill">
						{{data.pay_time | momentFmt}}
					</div>
				</div>
				<div class="m-b-5 fx m-r-5" v-if="data.refunds_time">
					<p class="w100">退款时间</p>
					<div class="fx-fill">
						{{data.refunds_time | momentFmt}}
					</div>
				</div>
			</div>
			<section class="m-t-15">
				<z-table :offset="0" :count="1" :total-count="1">
					<th slot="columns" v-for="item in columns">
						{{item}}
					</th>
					<tr slot="datasource" v-for="(item, index) in data.goods_list || []">
						<td><img :src="item.goodsFace" /></td>
						<td>{{item.goodsName}}</td>
						<td>{{item.goodsPrice | filterMoney}}元</td>
						<td>{{item.count}}</td>
						<td>
							<span v-if="item.title && item.text">
								{{item.title}} : {{item.text}}
							</span>
							<span v-else>无</span>
						</td>
					</tr>
					<div slot="operate">
						<a v-show="data.status == 1" class="z-btn z-btn-primary b-r-3" @click="handleSendGoods">发货</a>
						<a v-show="data.status == 1" class="z-btn z-btn-primary b-r-3 m-l-5" @click="handleRefund">退款</a>
					</div>
				</z-table>
			</section>
		</section>
		<!--:class="[isPopQr?'show-in':'hide-out']"-->
		<z-popup :showModel="this.isPopVmall">
			<div slot="popup-cont" class="popup-cont b-r-5">
				<p class="btn-close fx-align" @click="handleClose"><i class="icon-close"></i></p>
				<div class="fx fx-y-center">
					<div class="title fx w80 m-r-5"><span class="fx-fill">货运单号：</span></div>
					<div class="fx-fill">
						<input 
							type="text"  
							class="input b-r-5"
							v-model="codeNumber"
						/>
					</div>
				</div>
				<div><a class="btn-down" @click="handleDeliverGoods">确定</a></div>
			</div>
		</z-popup>
	</div>
</template>
<script>
	import { mapActions, mapState } from 'vuex'
	export default {
		name: 'OrderDetail',
		components: {},
		data() {
			return {
				data: {},
				params: {
					id: ''
				},
				columns: ['商品图片', '商品名称', '商品单价', '购买数量', '规格属性'],
				isPopVmall: false,
				codeNumber: '',//货运单号
			}
		},
		mounted() {
			this.params.id = this.$route.query.id || null
			if(this.$re_Number(this.params.id)) this.handleDetailInfo();
			
		},
		methods: {
			//打开弹层
			handleSendGoods() {
				this.isPopVmall = true;
			},
			
			//关闭弹层
			handleClose() {
				this.isPopVmall = false;
				this.codeNumber = null;
			},
			
			//处理发货
			async handleDeliverGoods() {
				if (!this.codeNumber) return this.$warning('请输入货运单号！');
				
				try{
					await this.deleverGoods({orderNo:this.data.order_no,codeNumber: this.codeNumber})
					this.$success('成功发货/(ㄒoㄒ)/~~');
					this.isPopVmall = false;
					this.handleDetailInfo()
				}catch(e){
					this.isPopVmall = false;
					this.$errorMsg('发货失败/(ㄒoㄒ)/~~');
				}
			},
			//获取订单详情
			handleDetailInfo() {
				this.getOrderInfo(this.params).then((data) => {
					this.data = data;
				}, () => {
					this.$errorMsg('获取数据失败/(ㄒoㄒ)/~~')
				})
			},
			
			//退款
			handleRefund() {
				if (!this.data.order_no) return this.$warning('缺少合法的参数order_no！');
				this.$confirm('退款将原路全部退还, 是否继续?', '提示', {
		          confirmButtonText: '确定',
		          cancelButtonText: '取消',
		          type: 'warning'
		        }).then(() => {
		          this.vmallRefund({orderNo: this.data.order_no}).then(()=>{
						this.$success('申请退款成功');
						this.$back();
					},(msg)=>{
						this.$errorMsg(msg);
					});
		        }).catch(() => {
		        		this.$log('取消')
		        });
			},
			...mapActions(['getOrderInfo', 'deleverGoods', 'vmallRefund']),
		},

//		beforeRouteEnter(to, from, next) {
//			next(vm => {
//				vm.params.orderId = to.query.orderId || null;
//				if(vm.params.orderId) {
//					vm.handleDetailInfo();
//				}
//			})
//		},
//
//		beforeRouteLeave(to, from, next) {
//			this.params.orderId = '';
//			next(true);
//		},
	}
</script>
<style lang="scss" scoped>
	@import "src/assets/css/common.scss";
	.content{
		border-top: none;
	}
	#content {
		min-height: px-em(400px);
	}
	
	.detail-cont {
		width: 600px;
		.status {
			&.success{
				color: $color-success;
			}
			&.ing{
				color:$color-warning;
			}
			&.fail{
				color: $color-wrong;
			}
			&.close{
				color: $color-gray;
			}
		}
	}
	
	.popup-cont{
		width: 400px;
		background: #fff;
		position: absolute;
		top: 50%;
		left: 50%;
		transform-origin: 0% -20%;
		padding: 20px;
		.btn-close{
			position: absolute;
			right: -40px;
			top: -0;
			color: #FF0000;
			cursor: pointer;
			border-radius: 50%;
			i{
				transition: all 0.2s ease;
				font-size: 24px;
				color: #fff;
			}
			&:active{
				i{
					transform: scale(0.8);
					color: #ccc;
				}
			}
		}
		.btn-down{
			width: 20%;
			background: $color-main;
			border-radius: 5px;
			display: block;
			color: #fff;
			font-weight: bold;
			font-size: 14px;
			text-align: center;
			padding: 5px 0;
			margin-top: 10px;
			transform: translate(0);
			&:active{
				opacity: 1;
				background: darken($color-main,5%);
				transform: scale(0.95);
			}
		}
	}
	
	table img {
		width: 80px;
	}
	@media only screen and (min-width:0px) and (max-width:640px) {
		.wrapper{
			min-width: px-em(1400px);
		}
	}
</style>


// WEBPACK FOOTER //
// OrderDetail.vue?5bf19389